// React Dependencies
import React, { useEffect, useState } from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { Box, Button } from '@material-ui/core';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

// Internal Dependencies
import Icons from '../../../components/Common/Icons';
import Colours from '../../../styles/colours';
import { Status, WindowSize } from '../../../common/constants';
import MText from '../../../components/Common/MText';
import sideBarStyle from '../../../styles/sidebar';
import { sideBarMenuItemFontSize } from '../../../styles/common';
import ApiService from '../../../services/apiService';

const LoyaltyProgramSidebarMenu = (props) => {
  const { loyaltyCardId, pageId } = props.match.params;

  const [loyaltyCardName, setLoyaltyCardName] = useState('-');
  const [loyaltyCardStatus, setLoyaltyCardStatus] = useState(Status.Draft);

  const getLoyaltyCard = async () => {
    try {
      const res = await ApiService.getLoyaltyCard(pageId, loyaltyCardId);

      const { name, status } = res;
      setLoyaltyCardName(name);
      setLoyaltyCardStatus(status);
    } catch (err) {
      console.log(err);
      toast.error(err.message);
    }
  };

  useEffect(() => {
    getLoyaltyCard();
  }, [loyaltyCardId, pageId]);

  return (
    <Box style={{
      position:   'fixed',
      top:        props.windowSize === WindowSize.Mobile ? '120px' : '130px',
      left:       props.windowSize === WindowSize.Mobile ? '85px' : '86px',
      zIndex:     '1000',
      background: '#fff',
      width:      props.windowSize === WindowSize.Mobile ? '215px' : sideBarStyle.width,
      height:     'calc(85vh - 70px)',
    }}
    >
      <Button
        className="block d-flex"
        onClick={props.onCloseMenuHandler}
        style={{ height: 50 }}
      >
        <div className="sub-menu-item pl-1 flex-row justify-content-start align-items-center">
          <Icons.ArrowBack colour={Colours.Gray2} />
          <MText className="pl-2" text="Loyalty Cards" colour={Colours.Gray2} size={sideBarMenuItemFontSize} />
        </div>
      </Button>

      <div style={{ paddingLeft: 20, marginBottom: 16 }}>
        <MText text="Loyalty card" colour={Colours.Gray2} />
        <MText text={loyaltyCardName} size={sideBarMenuItemFontSize} />
      </div>

      {
        props.menuItems.map((item) => {
          if (item.id === 5 && loyaltyCardStatus !== Status.Live) {
            return null;
          }

          return (
            <Button
              key={item.url}
              className="block p-0"
              onClick={() => props.onSelectMenuHandler(item)}
            >
              <div className="sub-menu-item">
                <MText
                  text={item.name}
                  size={sideBarMenuItemFontSize}
                  bold={props.selectedMenuItem && item.url === props.selectedMenuItem.url}
                />
              </div>
            </Button>
          );
        })
      }
    </Box>
  );
};

LoyaltyProgramSidebarMenu.propTypes = {
  menuItems:           PropTypes.arrayOf(PropTypes.shape(Object)).isRequired,
  selectedMenuItem:    PropTypes.shape(Object).isRequired,
  onSelectMenuHandler: PropTypes.func.isRequired,
  onCloseMenuHandler:  PropTypes.func.isRequired,
  windowSize:          PropTypes.string.isRequired,
  match:               PropTypes.shape(Object).isRequired,
};

const mapStateToProps = (state) => ({
  windowSize: state.layout.windowSize,
});

export default connect(mapStateToProps)(LoyaltyProgramSidebarMenu);
